import Hero from '../components/Hero';
import ActivitiesOverview from '../components/ActivitiesOverview';
import Team from '../components/Team';
import Faq from '../components/Faq';
import GoogleReviewsWidget from '../components/GoogleReviewsWidget';
import CoverageContactSection from '../components/CoverageContactSection';
import ClientSpaceSection from '../components/ClientSpaceSection';
import PricingSection from '../components/PricingSection';
import { useSeoMeta } from '../hooks/useSeoMeta';
import { useScrollToHash } from '../hooks/useScrollToHash';
import { buildFaqSchema } from '../utils/structuredData';
import { HOME_FAQ_SHORT } from '../data/homeFaq';

const HOME_JSON_LD = [buildFaqSchema(HOME_FAQ_SHORT)];

const HomePage = () => {
  useScrollToHash();
  useSeoMeta({
    title: 'Réparation iPhone et informatique à Viry – SOS IT Services',
    description:
      'Réparation iPhone à Viry, près de Genève : écran, batterie, vitre arrière, connecteur de charge. Réparation PC et Mac à domicile, 7j/7.',
    path: '/',
    jsonLd: HOME_JSON_LD,
  });

  return (
    <>
      <Hero />
      <CoverageContactSection />
      <ActivitiesOverview />
      <PricingSection />
      <ClientSpaceSection />
      <Team />
      <GoogleReviewsWidget />
      <Faq />
    </>
  );
};

export default HomePage;
